const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Resolve a stored image reference to a displayable URL.
// Absolute URLs (seed/stock photos) pass through; relative /api/files/... paths
// are prefixed with the backend origin.
export const imgUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  return `${BACKEND_URL}${src}`;
};
